import { render, staticRenderFns } from "./HeaderNavDropdown.vue?vue&type=template&id=0640120a&"
import script from "./HeaderNavDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderNavDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports